export const EDUZAP_V1ResourcesEN: EDUZAP_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errorMissingInput: "Please fill in all fields",
  buttonEdu: "Fill in education",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    edu: {
      pickTitle: "Add new education",
      label: "Education",
      name: "education",
      placeholder: "Add new education",
    },
    signatureTitle: "Signature",
    datum: {
      label: "Date",
      placeholder: "Please enter date",
      name: "datum",
    },
    dokument: {
      label: "Document",
      placeholder: "Please enter document",
      name: "dokument",
      description: () => (
        <>
          <h4>Drop files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
    },
    cilj: {
      label: "Education goal",
      name: "cilj",
      placeholder: "Please enter education goal",
    },
    izvrsilacObuke: {
      label: "Training instructor",
      name: "izvrsilacObuke",
      placeholder: "Please enter training instructor",
    },
    radnoMjesto: {
      label: "Workplace",
      name: "radnoMjesto",
      placeholder: "Please enter workplace",
    },
    mjestoObuke: {
      label: "Training location",
      name: "mjestoObuke",
      placeholder: "Please enter training location",
    },
    tema: {
      label: "Topic",
      name: "tema",
      placeholder: "Please enter topic",
    },
    verifikacijaEfikasnosti: {
      label: "Efficiency verification",
      name: "verifikacijaEfikasnosti",
      placeholder: "Please enter efficiency verification",
    },
    tipInput: {
      label: "Type",
      name: "tip",
      placeholder: "Please enter education type",
    },
    tip: {
      internal: "Internal education",
      external: "External education",
      unedefined: "Please select education type",
    },
    verifikacijaEdukatoraPotpis: "Verification - Educator Signature",
    verifikacijaPrisustvaPotpis: "Verification - Attendance Signature",
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
};

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
}

interface Tip {
  internal: string;
  external: string;
  unedefined: string;
}

interface PickEdu {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
  pickTitle: string;
}

interface Input {
  edu: PickEdu;
  signatureTitle: string;
  datum: InputField;
  dokument: InputField;
  cilj: InputField;
  izvrsilacObuke: InputField;
  radnoMjesto: InputField;
  mjestoObuke: InputField;
  tema: InputField;
  verifikacijaEfikasnosti: InputField;
  tipInput: InputField;
  tip: Tip;
  verifikacijaEdukatoraPotpis: string;
  verifikacijaPrisustvaPotpis: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface EDUZAP_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  buttonEdu: string;
  errors: IErrors;
}
